import { Route, Switch } from 'react-router-dom'
import React, { Component } from 'react'
import SelectStore from './select-store'
import Booking from './booking'
import BookDetail from './book-detail/index'
import WriteInfo from './write-info/index'

export default class Payment extends Component {
  render() {
    const { match }: any = this.props
    return (
      <div className="book-wrap">
        <Switch>
          <Route
            exact
            path={`${match.path}/select-store`}
            component={SelectStore}
          />
          <Route exact path={`${match.path}/booking`} component={Booking} />
          <Route
            exact
            path={`${match.path}/book-detail`}
            component={BookDetail}
          />
          <Route
            exact
            path={`${match.path}/write-info`}
            component={WriteInfo} />
        </Switch>
      </div>
    )
  }
}
